import { render, staticRenderFns } from "./RecordData.vue?vue&type=template&id=44528182&scoped=true"
import script from "./RecordData.vue?vue&type=script&lang=js"
export * from "./RecordData.vue?vue&type=script&lang=js"
import style0 from "./RecordData.vue?vue&type=style&index=0&id=44528182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44528182",
  null
  
)

export default component.exports